import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);
  return <section ref={ref} className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-charcoal" data-id="element-99">
      {/* Video Background */}
      <motion.div className="absolute inset-0 z-0" style={{
      y,
      scale: 1.1
    }} data-id="element-100">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover" data-id="element-101">
          <source src="https://code-11.hr/wp-content/uploads/2026/01/VIDEO-2025-10-26-15-13-10.mp4" type="video/mp4" data-id="element-102" />
        </video>
        <div className="absolute inset-0 bg-charcoal/50" data-id="element-103" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto" data-id="element-104">
        <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white mb-6 leading-tight font-normal" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.2
      }} data-id="element-105">
          Your Dream Wedding <br data-id="element-106" />
          <span className="italic text-white/90" data-id="element-107">at Code 11</span>
        </motion.h1>

        <motion.p className="text-base md:text-lg font-sans text-white/70 font-light italic max-w-2xl mx-auto" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.2,
        delay: 0.6
      }} data-id="element-108">
          "It's not just a wedding, it's the code to your story..."
        </motion.p>

        <motion.p className="text-2xl md:text-3xl font-script text-copper mt-8" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.9
      }} data-id="element-109">
          Diamond premium booking
        </motion.p>

        <motion.div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 1.1
      }} data-id="element-110">
          <Link to="/weddings-pricing" className="group inline-flex items-center gap-3 px-8 py-4 bg-copper text-charcoal hover:bg-copper/90 transition-all duration-500 font-sans text-xs uppercase tracking-[0.2em]" data-id="element-111">
            <span data-id="element-112">View Prices & Packages</span>
            <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} data-id="element-113" />
          </Link>
          <a href="#contact" className="group inline-flex items-center gap-3 px-8 py-4 border border-white/40 text-white hover:bg-white hover:text-charcoal transition-all duration-500 font-sans text-xs uppercase tracking-[0.2em]" data-id="element-114">
            <span data-id="element-115">Inquire Now</span>
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1.2,
      delay: 1
    }} data-id="element-116">
        <motion.div className="w-[1px] h-16 bg-gradient-to-b from-white/0 via-white/50 to-white/0" animate={{
        y: [0, 20, 0],
        opacity: [0.3, 1, 0.3]
      }} transition={{
        repeat: Infinity,
        duration: 2.5,
        ease: 'easeInOut'
      }} data-id="element-117" />
      </motion.div>
    </section>;
}